import React from 'react';
import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';
import Introduction from './components/nama/Introduction';
import NamaGiveawayForm from '../../components/forms/NamaGiveawayForm';

const NamaGiveawayRoot = styled('div')(({ theme }) => ({}));

const NamaGiveaway = () => {
    return (
        <Fade in={true}>
            <NamaGiveawayRoot>
                <Introduction />

                <NamaGiveawayForm />
            </NamaGiveawayRoot>
        </Fade>
    );
};

export default NamaGiveaway;
